<template>
    <div>
        <v-row dense  v-for="property in items" :key="property.id">
            <v-col>
                <card-property :item="property" @callSetDialog="setDialog" @callDestroyProperty="destroyProperty" />
            </v-col>
        </v-row>

        <!-- Dialog  -->
        <v-dialog 
            class="d-print-none"
            v-if="item && item != ''"
            v-model="dialog" 
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-system-bar
                class="d-print-none"
                dark
                :color="module == 'slideshow' ? 'black' : 'primary'"
                :height="module == 'slideshow' ? '5px' : '10px'"
            >    
            </v-system-bar>   
 
            <v-card :color="module == 'slideshow' ? 'black' : null" :class="module == 'showitem' ? 'background' : null">
                <v-card elevation="0" :color="module == 'slideshow' ? 'black' : null">
                    <v-card-title v-if="module != 'slideshow'" :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-1 font-weight-medium d-print-none' : 'text-h5 d-print-none'">
                        <v-row dense>
                            <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <span v-if="item.codigo">
                                    Código {{item.codigo}} - 
                                    {{ item.tipo_imovel }} 
                                    <span v-if="item.sub_tipo_imovel"> ({{ item.sub_tipo_imovel }})</span> 

                                    <span v-if="item.tipo_imovel == 'Conjunto'"> {{ item.finalidade }}</span>    

                                </span>
                            </v-col>  

                            <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="text-right">
                                <v-row dense class="text-right">
                                    <v-spacer></v-spacer>
                                    <v-col cols="auto">
                                        <button-share-component v-if="item.codigo" class="mr-4" :object="item"></button-share-component>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-tooltip top v-if="item.codigo">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-if="me.profile === 'Master'" icon @click="openCloseDialogCopy(item.id)" class="mr-4">
                                                    <v-icon v-bind="attrs" v-on="on">mdi-content-copy</v-icon>
                                                </v-btn>
                                                
                                                <v-btn v-else icon @click="confirmCopyItem(item.id)" class="mr-4">
                                                    <v-icon v-bind="attrs" v-on="on">mdi-content-copy</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Gerar cópia</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-tooltip top v-if="item.codigo">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon @click="openCloseDialogVisit()" class="mr-4">
                                                    <v-icon v-bind="attrs" v-on="on">mdi-home-account</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Imprimir Ficha Visita</span>
                                        </v-tooltip>  
                                    </v-col> 
                                    <v-col cols="auto">
                                        <v-tooltip top v-if="item.codigo && (me.profile == 'Master' || me.profile == 'Gerente')">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon @click="printFullProperty()" class="mr-4">
                                                    <v-icon v-bind="attrs" v-on="on">mdi-cloud-print-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Imprimir Ficha Completa</span>
                                        </v-tooltip>  
                                    </v-col> 
                                    <v-col cols="auto">
                                        <v-tooltip top v-if="item.codigo">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon @click="loadBranchVuex(item.branch_id)" class="mr-4">
                                                    <v-icon v-bind="attrs" v-on="on">mdi-printer-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Imprimir</span>
                                        </v-tooltip>  
                                    </v-col>  
                                    <v-col cols="auto">
                                        <v-btn icon @click="openCloseDialog()">
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>               
                            </v-col>      
                        </v-row>
                    </v-card-title>

                    <div v-else class="text-right">
                        <v-btn color="white" small outlined @click="openCloseDialog()">
                            FECHAR <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card>

                <v-divider class="d-print-none"></v-divider>

                <v-container>
                    <v-row dense>
                        <v-col cols="12">
                            <edit-portal-component v-if="module == 'portals'" :object="item" />
                            <splide-carousel-thumb v-if="module == 'slideshow'" :photos="item.photos_total" />
                            <property-show v-if="module == 'showitem' && item.id" :object="item" />
                        </v-col>  
                    </v-row>     
                </v-container>
            </v-card>   
        </v-dialog>
        <!-- End Dialog -->

        <!-- Dialog visit -->
        <v-dialog 
            class="d-print-none"
            v-if="item && item != ''"
            v-model="dialog_visit" 
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-system-bar
                class="d-print-none"
                dark
                color="primary"
                height="10px"
            >    
            </v-system-bar>   
 

            <v-card>
                <v-card-title class="text-h5 d-print-none">
                    <span v-if="item.codigo">Código {{item.codigo}} - {{ item.tipo_imovel }} <span v-if="item.sub_tipo_imovel"> ({{ item.sub_tipo_imovel }})</span> </span>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="openCloseDialogVisit()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider class="d-print-none"></v-divider>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <form-visit :multiple_codigo="multiple_codigo" />
                        </v-col>  
                    </v-row>     
                </v-container>
            </v-card>   
        </v-dialog>
        <!-- End Dialog -->


        <!-- Dialog Display -->
        <v-dialog 
            class="d-print-none"
            v-if="item && item != ''"
            v-model="dialog_print" 
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-system-bar
                class="d-print-none"
                dark
                color="primary"
                height="10px"
            >    
            </v-system-bar>   
 

            <v-card>
                <v-card-title class="text-h5 d-print-none">
                    <span v-if="item.codigo">Código {{item.codigo}} - {{ item.tipo_imovel }} <span v-if="item.sub_tipo_imovel"> ({{ item.sub_tipo_imovel }})</span> </span>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="openCloseDialogPrint()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider class="d-print-none"></v-divider>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <display-component :object="item" :branch_logo="branch_logo"></display-component> 
                        </v-col>
                    </v-row>     
                </v-container>
            </v-card>   
        </v-dialog>
        <!-- End Dialog -->

        <!-- Dialog Display -->
        <v-dialog 
            class="d-print-none"
            v-if="item && item != ''"
            v-model="dialog_copy" 
            max-width="600"

        >
           
            <v-card>
                <v-card-title :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-1 font-weight-medium d-print-none' : 'text-h5 d-print-none'">
                    Deseja copiar os dados do proprietário?
                </v-card-title>
                <v-card-text>Ao copiar os dados do proprietário, os captadores do novo imóvel poderão editar os dados do proprietário. </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red darken-1"
                        text
                        @click="openCloseDialogCopy()"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="copyItem(item.id)"
                    >
                        Copiar Imóvel
                    </v-btn>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="copyItemMaster(item.id)"
                    >
                        Copiar Imovel + proprietário
                    </v-btn>
                </v-card-actions>
            </v-card>
                  
        </v-dialog>


    </div>
</template>


<script>
import CardProperty from './CardProperty.vue';
import EditPortalComponent from '@/components/properties2/partials/EditPortalComponent.vue';
import SplideCarouselThumb from '@/components/carousel/SplideCarouselThumb.vue';
import PropertyShow from './PropertyShow.vue';
import ButtonShareComponent from '@/components/button_share/ButtonShareComponent.vue'
import FormVisit from './FormVisit.vue';
import DisplayComponent from './print/DisplayComponent.vue'

export default {
    components: {
        CardProperty,
        EditPortalComponent,
        SplideCarouselThumb,
        PropertyShow,
        ButtonShareComponent,
        FormVisit,
        DisplayComponent
    },

    props: {
        items: {
            type: Array, // Adicione o tipo
            required: false, // Corrigido: "required" em vez de "require"
            default: () => [] // Adicione um valor padrão para arrays
        },
    },

    computed: {
        me () {
          return this.$store.state.auth.me
        },
    },    

    data () {
        return {
            item: {},
            dialog: false,
            dialog_print: false,
            module: '',
            dialog_visit: false,
            dialog_copy: false,
            multiple_codigo: null,
            branch_logo: null,
        }
    },

    methods: {
        openCloseDialog(){
            this.dialog = !this.dialog;
            if(!this.dialog){
                this.module = '';
            }
        },

        setDialog(params){
            this.module = params.module;
            switch (this.module) {
                case 'portals':
                    this.editPortal(params.item.id)
                    break
                case 'slideshow':
                    this.slideShow(params.item)
                    break
                case 'showitem':
                    this.showItem(params.item)
                    break                                        
                default:
                    console.log('Ação não reconhecida')
                    break
            }
        },

        editPortal (id) {  
            this.$store.dispatch('loadShowPortalProperty', id) 
                        .then(response => {
                            this.item = response.data
                            this.dialog = true
                        });
        },

        slideShow(item){
            this.item = item; 
            this.dialog = true;
        },

        showItem(item){
            this.item = {};
            this.$store.dispatch('loadProperty', item.id) 
                        .then(response => {
                            this.item = response.data
                            this.dialog = true
                        });
            
            this.dialog = true;
        },

        /* ###### Copy property ##### */
        confirmCopyItem(id){
            this.$snotify.warning(`O sistema irá copiar esse registro. Deseja continuar?`, 'Confirmaçāo', {
                timeout: 10000,
                showProgressBar: true,
                closeоnClick: true,
                buttons: [
                    {text: 'Nāo', action: this.$snotify.remove()},
                    {text: 'Sim', action: () => {
                        this.copyItem(id)
                        this.$snotify.remove()
                    }},
                ]
            })
        },

        copyItem (id){
            const copy_params = {}
            copy_params.property_id = id
            copy_params.copy = 1
            this.$store.dispatch('copyProperty', copy_params) 
                        .then(response => {
                            const property = response.data

                            this.$router.push({
                                name: 'admin.properties2.edit',
                                params: { uuid: property.id }
                            });
                        })
        },

        copyItemMaster (id){
            const copy_params = {}
            copy_params.property_id = id
            copy_params.copy = 1
            copy_params.owners = true
            this.$store.dispatch('copyProperty', copy_params) 
                        .then(response => {
                            const property = response.data
                            this.dialog_copy = false;

                            this.$router.push({
                                name: 'admin.properties2.edit',
                                params: { uuid: property.id }
                            });
                        })
        },
        /* ###### Fim property ##### */

        /* ###### Visita ##### */
        openCloseDialogVisit(){
            this.multiple_codigo = this.item.codigo;
            this.dialog_visit = !this.dialog_visit;
        },
        /* ###### Copy property ##### */


        /* ###### Ficha PDF Completa ##### */
        printFullProperty(){
            const params = {}
            params.property_id = this.item.id;
            params.number_photos = 1;
            params.layout = 'portrait';
            params.file_name = 'ficha-codigo-' + this.item.codigo + '.pdf';

            this.$store.dispatch('printFullProperty', params) 
                        .then(response => {
                           this.$snotify.success('Download em andamento');
                        })
            
        },
        /* ###### Fim Ficha PDF Completa ##### */

        openCloseDialogCopy(){
            this.multiple_codigo = this.item.codigo;
            this.dialog_visit = false;
            this.dialog_copy = !this.dialog_copy; 
        },

        loadBranchVuex (id) {    
            this.dialog = false
            this.$store.dispatch('loadBranchVuex', id) 
                        .then(response => {
                           this.setLogo(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            this.$snotify.error('Erro no cadastro')
                        })
        },

        setLogo (branch){
            if(branch.branchimages && branch.branchimages.length > 0){
                const result = branch.branchimages.filter(model => model.description == 'Logo quadrado')
                this.branch_logo = result[0].urlremoto
            }
            this.openCloseDialogPrint()
        },

        openCloseDialogPrint(){
            this.dialog = false
            this.dialog_print = !this.dialog_print
        },

        destroyProperty(id){
            this.$emit('callDestroyProperty', id);
        }

    }
}
</script>